/**
 * Wave 3C — state-based “what’s next” (borrow Dir2, Direction 1 lock).
 * One quiet line from saved state. Not a second CTA banner. Not a wizard gate.
 */

import { pathRoomPath } from './pathRoomPath';
import { columnHandoff } from './plottrackGrid';
import { draftThisScenePath } from './sceneWritingPath';
import {
  DRAFT_THIS_SCENE,
  REVIEW_TASKS,
  WRITE_DRAFT,
} from './writerCopy';

export function storyHasMaterial(story) {
  if (!story) return false;
  return Boolean(
    String(story.log_line || '').trim()
    || String(story.theme || '').trim()
    || String(story.story_flavor || '').trim()
  );
}

export function sceneHasOutline(column, cell) {
  if (!column?.scene_id) return false;
  const note = String(cell?.note || column?.note || '').trim();
  const beats = column?.beats || cell?.beats || [];
  return Boolean(note || (Array.isArray(beats) && beats.some((beat) => String(beat || '').trim())));
}

export function journeyNextTip({
  stage,
  story,
  storyId,
  selectedColumn,
  selectedCell,
  outlineColumns = [],
  outlineCells = [],
  sceneCount = 0,
  scenesKnown = false,
} = {}) {
  const bookId = storyId || story?.id || null;

  if (stage === 'explore' && storyHasMaterial(story) && bookId) {
    return {
      text: 'Story material is ready.',
      action: REVIEW_TASKS,
      to: pathRoomPath(bookId),
    };
  }

  if (stage === 'plottrack') {
    if (selectedColumn?.scene_id && sceneHasOutline(selectedColumn, selectedCell)) {
      return {
        text: 'This scene has an outline.',
        action: DRAFT_THIS_SCENE,
        to: draftThisScenePath(bookId, columnHandoff(selectedColumn, selectedCell)),
      };
    }
    const outlined = outlineColumns.find((column) => (
      sceneHasOutline(column, outlineCells.find((cell) => (
        cell.column_id === column.id || cell.scene_id === column.scene_id
      )))
    ));
    if (outlined && bookId) {
      const outlinedCell = outlineCells.find((cell) => (
        cell.column_id === outlined.id || cell.scene_id === outlined.scene_id
      ));
      return {
        text: 'A scene has an outline.',
        action: DRAFT_THIS_SCENE,
        to: draftThisScenePath(bookId, columnHandoff(outlined, outlinedCell)),
      };
    }
  }

  if (stage === 'scene-writing') {
    // An empty draft room stays here. A link back to the grid is a loop.
    if (scenesKnown && sceneCount === 0) return null;
    if (sceneCount > 0) {
      return {
        text: 'This scene has an outline.',
        action: WRITE_DRAFT,
        to: null,
      };
    }
  }

  return null;
}
